import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  LoginEncontrado$ = new BehaviorSubject<any>(null);
  EmpresasEncontradas$ = new BehaviorSubject<any>(null);
  TokenEncontrado$ = new BehaviorSubject<any>(null);
  TrocarSenha$ = new BehaviorSubject<any>(null);

  public spinTrocarSenhaGlobal = false;

  constructor(private http: HttpClient, private toastr: ToastrService) { }

  get(login: any) {

    try {
      var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
      headers.append('Content-Type', 'application/json');

      let obj = {
        empresa: environment.empresa,
        usuario: login.usuario,
        senha: login.senha,
        ip: login.ip
      };

      var url: string = environment.advFirmasWebApi + '/Usuarios/Authenticate'

      Swal.fire({
        title: "",
        text: "Carregando...",
        icon: "warning",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: false
      });

      this.http.post(url, obj, { headers: headers })
        .subscribe({
          next: (res: any) => {
            let acesso = {
              "Usuario": login.usuario,
              "Token": res.access_token,
              "CodigoAcesso": res.codigo_acesso,
              "Sistemas": res.sistemas,
            }

            environment.usuario = login.usuario;
            environment.senha = login.senha;
            environment.expiracao = res.expira_em;
            environment.token = res.token;
            environment.id_autorizador = res.id_autorizador;
            environment.nr_cpf_autorizador = res.nr_cpf;
            environment.cd_login = res.cd_login;
            environment.cd_usuario = res.cd_usuario;

            this.LoginEncontrado$.next(acesso);
            Swal.fire({
              title: "Bem Vindo(a)",
              text: "Login Efetuado com Sucesso!",
              icon: "success",
              timer: 1500,
              showCancelButton: false,
              showConfirmButton: false
            });
          },
          complete: () => {
            if (this.LoginEncontrado$.value || this.LoginEncontrado$.value.Usuario) {
              this.LoginEncontrado$.unsubscribe();
              this.LoginEncontrado$ = new BehaviorSubject<any>(null);
            }
          },
          error: (error: HttpErrorResponse) => {
            if (error.status == 400) {
              Swal.fire('Eiii!?...', 'Acesso inválido, por favor efetue o login novamente!', 'error');
            } else if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  obterTokenTrocarSenha(trocarSenha: any) {
    try {
      var obj: any = {
        email: trocarSenha.email,
        empresa: environment.empresa,

      }
      this.spinTrocarSenhaGlobal = true;
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/AutorizadorInterno/RecuperarSenha/RequisitarToken";
      var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
      headers.append('Content-Type', 'application/json');
      this.http.post(url, obj, { headers: headers })
        .subscribe({
          next: (res: any) => this.TokenEncontrado$.next(res),
          error: (error: HttpErrorResponse) => {
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else if(error.status === 400 || error.status === 404) {
              console.log(error.status);
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
            this.spinTrocarSenhaGlobal = false;

          }
        }).add(() => {
          this.TokenEncontrado$.unsubscribe(),
            this.TokenEncontrado$ = new BehaviorSubject(null);
        });
    } catch (e) {
      this.spinTrocarSenhaGlobal = false;
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  TrocarSenha(trocarSenha: any) {
    try {
      var obj: any = {
        token: trocarSenha.token,
        senha: trocarSenha.nova_senha,
        cd_login : trocarSenha.login,
        empresa: environment.empresa,
        email: trocarSenha.email

      }
      this.spinTrocarSenhaGlobal = true;
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/AutorizadorInterno/RecuperarSenha/RecuperarSenha";
      var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
      headers.append('Content-Type', 'application/json');

      this.http.post(url, obj, { headers: headers })
        .subscribe({
          next: (res: any) => this.TrocarSenha$.next(res),
          error: (error: HttpErrorResponse) => {
            console.log(error);
            this.spinTrocarSenhaGlobal = false;
            if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else if(error.status === 400 || error.status === 404) {
              console.log(error.status);
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        }).add(() => {
          this.TrocarSenha$.unsubscribe(),
            this.TrocarSenha$ = new BehaviorSubject(null);
        });
    } catch (e) {
     
      this.spinTrocarSenhaGlobal = false;
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }

  
  getEmpresas() {

    try {
      var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
      headers.append('Content-Type', 'application/json');

      var url: string = environment.advFirmasWebApi + '/Usuarios/Authenticate'
      var body: any = {
        "CodigoEmpresa": 1,
        "CodigoUsuario": environment.cd_usuario,
        "CodigoAcesso": "",
        "Token": environment.token,
        "Sistemas": ["2020"]
      };

      this.http.get(url, { params: { body } }).subscribe({
        next: (res: any) => {
          var temp: any = res;
        },
        complete: () => {
          if (!this.EmpresasEncontradas$.value || !this.EmpresasEncontradas$.value.Usuario) {
            this.EmpresasEncontradas$.unsubscribe();
            this.EmpresasEncontradas$ = new BehaviorSubject<any>(null);
          }
        },
        error: (error: HttpErrorResponse) => {
          if (error.status == 400) {
            Swal.fire('Eiii!?...', 'Acesso inválido, por favor efetue o login novamente!', 'error');
          } else if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }
}
